import { render } from "./import.vue?vue&type=template&id=7234ce6a"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"
script.render = render

export default script